import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
import { uniqueId } from 'lodash'; // 插件

import demoPlugins from './modules/demo-plugins'; // 组件

import demoComponents from './modules/demo-components'; // 功能

import demoPlayground from './modules/demo-playground';
/**
 * @description 给菜单数据补充上 path 字段
 * @description https://github.com/d2-projects/d2-admin/issues/209
 * @param {Array} menu 原始的菜单数据
 */

function supplementPath(menu) {
  return menu.map(function (e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      path: e.path || uniqueId('d2-menu-empty-')
    }, e.children ? {
      children: supplementPath(e.children)
    } : {});
  });
} // 菜单 侧边栏


export var menuAside = supplementPath([demoComponents, demoPlugins, demoPlayground]); // 菜单 顶栏

export var menuHeader = supplementPath([{
  path: '/index',
  title: '首页',
  icon: 'home'
} // demoPlayground,
// demoComponents,
// demoPlugins
]);